module.exports = __webpack_public_path__ + "img/trouble@2x.559638b9.png";